import React, { useCallback } from 'react';
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMenuStructure } from '../../hooks/useMenuStructure';
import HorizontalMenuList from './HorizontalMenuList';
import MenuSkeleton from './MenuSkeleton';
import { LAYOUT_CONFIG } from '../../../../constants/layout';
import { MenuItem } from '../../types';

const HorizontalNavContainer = styled('nav')(({ theme }) => ({
  backgroundColor: theme.palette.layout.sidebarDark,
  borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
  height: LAYOUT_CONFIG.horizontalMenuHeight,
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'fixed',
  top: LAYOUT_CONFIG.headerHeight,
  left: 0,
  zIndex: 1000,
  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
}));

const HorizontalNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { menuItems: menuStructure, loading } = useMenuStructure();

  const handleMenuItemClick = useCallback((item: MenuItem) => {
    if (item.path) navigate(item.path);
  }, [navigate]);

  return (
    <HorizontalNavContainer>
      <Container maxWidth={false} sx={{ px: 2, display: 'flex', alignItems: 'center', height: '100%' }}>
        {loading ? (
          <MenuSkeleton horizontal />
        ) : (
          <HorizontalMenuList
            menuItems={menuStructure}
            onItemClick={handleMenuItemClick}
            currentPath={location.pathname}
          />
        )}
      </Container>
    </HorizontalNavContainer>
  );
};

export default HorizontalNavbar;
